const $$splitComponentImporter = () => import('/src/src/routes/_anonymous/mobile_sign_in.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_anonymous/mobile_sign_in")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});